<template>
  <div>
    <v-card class="storyImageCard" color="secondaryBackground">
      <v-container>
        <v-hover v-slot="{ hover }">
          <v-card v-show="validImageUrl" hover>
            <v-img class="storyImage" :src="coverArtUrl"> </v-img>
            <v-fade-transition>
              <v-overlay absolute :value="hover">
                <v-btn color="success" @click="$refs.imageUpload.click()">
                  {{ $t("story.coverArt.changeImage") }}
                </v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </v-hover>
        <v-card
          v-if="!validImageUrl"
          @click="$refs.imageUpload.click()"
          id="addImage"
          color="secondaryBackground"
          class="d-flex flex-column justify-center align-center"
          flat
        >
          <v-icon>mdi-plus</v-icon>
          {{ $t("story.coverArt.addImage") }}
        </v-card>
        <v-card-text>
          <div>{{ $t("story.coverArt.fileFormat") }}</div>
          <div>
            {{
              $t("story.coverArt.recommended", { maxSizeMb: MAX_IMAGE_SIZE_MB })
            }}
          </div>
        </v-card-text>
        <div class="text-left my-3" v-if="loading">
          {{ $t("forms.uploading") }}
          <v-progress-linear
            indeterminate
            color="primaryAction darken-2"
          ></v-progress-linear>
        </div>
        <upload-error-message :errorMessage="errorMessage" :loading="loading" />
      </v-container>
    </v-card>
    <input
      v-show="false"
      ref="imageUpload"
      type="file"
      :rules="rules.imageSize"
      :accept="imageFormats"
      @change="onFileUpload($event)"
    />
  </div>
</template>

<script>
import axios from "axios";
import {
  IMAGE_FORMATS,
  MAX_IMAGE_UPLOAD_BYTES,
  MAX_IMAGE_UPLOAD_MEGABYTES,
} from "@/const";
import gql from "graphql-tag";
import iris from "@/iris";
import { AUTH_TOKEN } from "@/apollo/vue-apollo";
import UploadErrorMessage from '../../../TextEditor/UploadErrorMessage.vue';
export default {
  name: "StoryImageCard",
  components: {
    UploadErrorMessage,
  },
  computed: {
    imageFormats() {
      return IMAGE_FORMATS;
    },
    id() {
      return `${iris.story}${this.$route.params.id}`;
    },
    serverHost() {
      return process.env.VUE_APP_SERVER_HOST;
    },
    validImageUrl() {
      return this.coverArtUrl != undefined && this.coverArtUrl != "";
    },
    jwt() {
      return localStorage.getItem(AUTH_TOKEN);
    },
    MAX_IMAGE_SIZE_MB() {
      return MAX_IMAGE_UPLOAD_MEGABYTES;
    },
  },
  apollo: {
    coverArtUrl: {
      query: gql`
        query GetStory($id: ID!) {
          story(id: $id) {
            id
            coverArt {
              id
              contentUrl
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      update(data) {
        let story = data.story;
        this.storyId = story.id;
        if (story.coverArt) {
          return story.coverArt.contentUrl;
        } else {
          return "";
        }
      },
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },
  data() {
    return {
      image: "",
      loading: false,
      errorMessage: null,
      rules: {
        imageSize: (value) => !value || value.size < MAX_IMAGE_UPLOAD_BYTES,
      },
      storyId: "",
    };
  },
  methods: {
    onFileUpload(e) {
      this.errorMessage = null
      this.loading = true;
      const reader = new FileReader();
      const file = e.target.files[0];
      if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
        this.errorMessage = this.$t("register.imageTooLarge", {
          maxImageSize: MAX_IMAGE_UPLOAD_MEGABYTES,
        });
        this.loading = false;
        return;
      }
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = async () => {
        try {
          this.errorMessage = null
          this.image = reader.result;
          let bodyFormData = new FormData();
          bodyFormData.append("file", e.target.files[0]);
          bodyFormData.append("storyId", this.storyId);
          bodyFormData.append("coverArt", "true");
          let result = await axios.post(
            this.serverHost + "/media_objects",
            bodyFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + this.jwt,
              },
            }
          );
          this.loading = false;
          this.coverArtUrl = result.data.contentUrl;
          this.$apollo.queries.coverArtUrl.refresh();
        } catch (e) {
          this.loading = false;
          this.errorMessage = e.message;
        }
      };
    },
  },
};
</script>

<style>
.storyImageCard {
  min-height: 622px;
}
.storyImage {
  height: 520px;
}
#addImage {
  height: 520px;
}
</style>
